import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixEcomDeliveryprofileV1DeliveryRatesUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/delivery-rates',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/delivery-rates',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_ecom_delivery-solutions';

/** Get Delivery Solutions for the given line items from all relevant delivery carriers */
export function getDeliverySolutions(
  payload: object
): RequestOptionsFactory<any> {
  function __getDeliverySolutions({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'lineItems.physicalProperties.weight' },
          { path: 'destination.geocode.latitude' },
          { path: 'destination.geocode.longitude' },
          { path: 'origin.geocode.latitude' },
          { path: 'origin.geocode.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.gateways.ecom.v1.delivery_rates_gateway',
      method: 'POST' as any,
      methodFqn:
        'wix.ecom.deliveryprofile.v1.DeliveryRates.GetDeliverySolutions',
      packageName: PACKAGE_NAME,
      url: resolveWixEcomDeliveryprofileV1DeliveryRatesUrl({
        protoPath: '/v1/get-delivery-solutions',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'deliverySolutions.logistics.pickupDetails.address.geocode.latitude',
              },
              {
                path: 'deliverySolutions.logistics.pickupDetails.address.geocode.longitude',
              },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'deliverySolutions.logistics.deliveryTimeSlot.from' },
              { path: 'deliverySolutions.logistics.deliveryTimeSlot.to' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getDeliverySolutions;
}
